import React, {useMemo} from "react";
import {Route} from "@/routing/Router";
import {Icon, SidebarNavigationButton, SidebarNavigationSection, SidebarSectionLabel} from "peggirkit";
import {useIntl} from "react-intl";
import {ArrowTopRightOnSquareIcon} from "@heroicons/react/24/outline";
import {adminMenuSections, MenuItem, MenuSection, posMenuSections} from "./MenuItems";
import useAuth from "@/context/authentication/use-auth";

type Props = {
    currentPage: Route,
}

const SidebarMenu = ({currentPage}: Props) => {
    const intl = useIntl();
    const {mainRole} = useAuth();
    const menuSections: MenuSection[] = useMemo(
        () => mainRole === "ROLE_POS" ? posMenuSections : adminMenuSections,
        [mainRole]);

    return <>
        {menuSections.map((section: MenuSection, i: number) =>
            <SidebarNavigationSection
                key={i}
                label={
                    section.name &&
                    <SidebarSectionLabel
                        textColorClassname={"text-black/60 dark:text-white/60"}
                        name={section.name(intl)}
                    />
                }
                itemsIconClassname={() => "text-eat-yellow-800 dark:text-eat-yellow-600"}
            >
                {section.items.map((item: MenuItem, i2: number) =>
                    <SidebarNavigationButton
                        key={i2}
                        buttonAction={{
                            as: "reactRouterLink",
                            actionProps: "href" in item
                                ? {to: item.href, rel: "noopener", target: "_blank"}
                                : {to: item.route.absolutePath()}
                        }}
                        icon={item.icon}
                        iconAfter={
                            "href" in item
                                ? <Icon className={"opacity-60"} icon={ArrowTopRightOnSquareIcon}/>
                                : undefined
                        }
                        badge={item.after && item.after()}
                        selected={"route" in item && (currentPage.name(intl) === item.route.name(intl))}
                    >
                        {
                            "href" in item
                                ? item.name
                                : item.route.name(intl)
                        }
                    </SidebarNavigationButton>
                )}
            </SidebarNavigationSection>
        )}
    </>
};

export default SidebarMenu;